import { render, staticRenderFns } from "./RenewContainer.vue?vue&type=template&id=6d6fdaa6&"
import script from "./RenewContainer.vue?vue&type=script&lang=js&"
export * from "./RenewContainer.vue?vue&type=script&lang=js&"
import style0 from "./RenewContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports